export default __webpack_public_path__ + "static/media/momo03.97755614.png";